import React from 'react';
import { PdfHuchaCardContainer } from '../../../ui/pdf-hucha-card-container';
import { PdfHuchaRenovadoresCardC2 } from './pdf-hucha-renovadores-card-c2';
import { PdfHuchaRenovadoresCardC3 } from './pdf-hucha-renovadores-card-c3';

export const PdfHuchaRenovadoresCard: React.FC<{
	dineroHucha: string;
}> = ({ dineroHucha }) => {
	return (
		<PdfHuchaCardContainer>
			<PdfHuchaRenovadoresCardC2 dineroHucha={dineroHucha} />
			<PdfHuchaRenovadoresCardC3 />
		</PdfHuchaCardContainer>
	);
};
